/**
 * 匿名トークン（要件2.1、2.2）。
 *
 * 初回アクセス時に生成して localStorage に保存する。これがそのまま playerId になり、
 * リロードや再接続で同じ席へ復帰する根拠になる（要件2.3）。ログインは一切要求しない。
 *
 * origin 単位で保存されるため、独自ドメインへ移行するとトークンは失われる。
 */

const TOKEN_KEY = 'chipless.token';
const NAME_KEY = 'chipless.name';

export function getToken(): string {
  const stored = globalThis.localStorage.getItem(TOKEN_KEY);
  if (stored !== null && stored.length >= 8) return stored;
  const created = globalThis.crypto.randomUUID();
  globalThis.localStorage.setItem(TOKEN_KEY, created);
  return created;
}

/** 表示名は毎回入れ直させたくないので覚えておく。 */
export function getSavedName(): string {
  return globalThis.localStorage.getItem(NAME_KEY) ?? '';
}

export function saveName(name: string): void {
  globalThis.localStorage.setItem(NAME_KEY, name);
}
